import { getSession, removeSession, setSession } from '@/utils/sessionStorage'

const KEY = 'nurm_pending_warehouse_switch_v1'
const TTL = 1000 * 30

type PendingWarehouseSwitch = {
  warehouseId: string
  timestamp: number
}

export const markPendingWarehouseSwitch = (warehouseId: string): void => {
  setSession<PendingWarehouseSwitch>(KEY, {
    warehouseId,
    timestamp: Date.now(),
  })
}

export const consumePendingWarehouseSwitch = (warehouseId: string): boolean => {
  const pending = getSession<PendingWarehouseSwitch>(KEY)

  if (!pending) {
    return false
  }

  const isExpired = Date.now() - pending.timestamp > TTL

  if (isExpired) {
    removeSession(KEY)
    return false
  }

  if (pending.warehouseId !== warehouseId) {
    return false
  }

  removeSession(KEY)
  return true
}
